import { createReducer } from '@reduxjs/toolkit';
import { ThemingState } from './types';
import { setTheme } from './actions';

const initialState: ThemingState = {
  theme: 'sap_horizon',
};

const themingReducer = createReducer(initialState, (builder) => {
  builder.addCase(setTheme, (state, action) => {
    state.theme = action.payload;
  });
});

export default themingReducer;
